// Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase,
// DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper,
// SplitText, CustomBounce, CustomWiggle,
import { gsap, ScrollTrigger, GSDevTools } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, GSDevTools);
export default () => {
  let mm = gsap.matchMedia();
  //------------------------------------------------------//
  // Setup 🧦 GSAP and register 📜 ScrollTrigger
  // Register more plugins like so: gsap.registerPlugin(ScrollTrigger, splitText);
  // Go to https://greensock.com/docs/v3/Installation?checked=core,scrollTrigger,splitText#installer
  //------------------------------------------------------//
  // gsap.registerPlugin(Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase, DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper, SplitText, CustomBounce, CustomWiggle);

  ScrollTrigger.defaults({
    toggleActions: "restart pause resume pause",
    markers: window.location.hostname.endsWith(".local") ? true : false,
  });

  // ? fix next wow
  // --------------------------------//
  // path animation 
  //--------------------------------//
  if (document.querySelector(".fancy-path")) {
    gsap.to(".fancy-path path", {
      strokeDashoffset: -140,
      duration: 7,
      repeat: -1,
      ease: "none"
    });
  }
  // END path animation --------------//
  //--------------------------------//
  // Scale up 
  //--------------------------------//
  document.querySelectorAll(".alloy-scale-up").forEach((container, index) => {
    const q = gsap.utils.selector(container);
    const tl = gsap.timeline({
      scrollTrigger: {
        id: `ScaleUp-${index}`,
        trigger: container,
        start: "top bottom-=10%",
        // End while the block is still mid-viewport; "center" made motion feel done only near the top.
        end: "bottom bottom-=25%",
        toggleActions: "play none none none",
      }
    });
    tl.from(q(".animate-item"), {
      scale: 0.6,
      y: 100,
      stagger: 0.1,

    });
  });
  // END Scale up --------------//

  //--------------------------------//
  // Scale up 
  //--------------------------------//
  document.querySelectorAll(".alloy-animate-up").forEach((container, index) => {
    const q = gsap.utils.selector(container);
    const tl = gsap.timeline({
      defaults: {
        ease: "none",
      },
      scrollTrigger: {
        id: `AnimateUp-${index}`,
        trigger: container,
        start: "top bottom-=10%",
        end: "bottom bottom+=0%",
        toggleActions: "play none none none",
        scrub: true,
      }
    });
    tl.from(q(".animate-item"), {
      y: 100,
      opacity: 0,
      stagger: 0.3,
    });
  });
  // END Animate up --------------//



  // END Setup 🧦 GSAP -------------------------------------//
};
